import { logger } from '@automata/utils';

import {
  ConditionProperties,
  ConditionPropertiesForm,
} from '../zodSchemas/conditionProperties';
import {
  TaskProperties,
  TaskPropertiesForm,
  TaskPropertiesPatch,
  taskPropertiesPatchSchema,
} from '../zodSchemas/taskProperties';

/** Deal with fields which conditionally change other fields in the task properties form. */
export function _processTaskFieldChange(
  formUpdate: Partial<TaskProperties>,
  prevProperties: TaskProperties
): Partial<TaskPropertiesPatch> {
  let relatedChanges: Partial<TaskPropertiesPatch> = {};

  if (
    formUpdate.instrumentId &&
    prevProperties.taskParameters !== null &&
    prevProperties.taskParameters.slot !== undefined
  ) {
    relatedChanges.taskParameters = {
      slot: '1',
    };
  }

  return { ...formUpdate, ...relatedChanges };
}

/** Generate a patch to apply to TaskProperties, given a change in one or more TaskPropertiesForm fields. */
export function createTaskFormPatch(
  formUpdate: Partial<TaskPropertiesForm>,
  prevProperties: TaskProperties
): TaskPropertiesPatch {
  const update = taskPropertiesPatchSchema.safeParse(formUpdate);
  if (update.success) {
    return _processTaskFieldChange(update.data, prevProperties);
  } else {
    logger.warn(
      'Could not create TaskProperties patch, validation failed',
      update.error,
      formUpdate
    );
  }
  return {};
}

export function createConditionFormPatch(
  formUpdate: Partial<ConditionPropertiesForm>,
  prevProperties: ConditionProperties
): ConditionPropertiesForm {
  return { ...prevProperties, ...formUpdate } as ConditionPropertiesForm;
}
